module.exports = __webpack_public_path__ + "static/media/08.111.b7ab8321.webp";